import { getApiClient } from 'adapter/out/client/apiClient';
import PresetPage from 'domain/entity/preset/presetPage/presetPage';
import ReadPresetPageCriteria from 'use-case/presets/presetPage/read/readPresetPageCriteria';

const getReadPresetPageApiClient = getApiClient(
    (criteria: ReadPresetPageCriteria) => `dashboards/preset-pages/pages/${criteria.presetPageId}`,
    PresetPage
);

export default getReadPresetPageApiClient;
